import { Box } from '@mantine/core';
import styles from './BodyContent.module.scss';

export function BodyContent(props: { children: React.ReactNode }): React.ReactNode {
	return <Box className={styles['bodyContent']}>{props.children}</Box>;
}
